const storeEssentialUserInfo = (storage, userInfo, rememberMeFlag) => {
  if (userInfo && userInfo.token) {
      const essentialInfo = {
          token: userInfo.token,
          id: userInfo.id || userInfo.user_id,
          nickname: userInfo.nickname,
          avatar: userInfo.avatar 
      };
      storage.setItem('userInfo', JSON.stringify(essentialInfo));
      saveRememberMe(rememberMeFlag); // 记录“记住我”的状态
  } else {
      console.error("尝试存储的用户信息无效或缺少token:", userInfo);
  }
};

// export const saveUserInfoToLocal = (userInfo) => {
//   localStorage.setItem('userInfo', JSON.stringify(userInfo));
//   saveRememberMe(true);
// };
export const saveUserInfoToLocal = (userInfo) => {
  storeEssentialUserInfo(localStorage, userInfo, true);
};

// export const saveUserInfoToSession = (userInfo) => {
//   sessionStorage.setItem('userInfo', JSON.stringify(userInfo));
//   saveRememberMe(false);
// };
export const saveUserInfoToSession = (userInfo) => {
  storeEssentialUserInfo(sessionStorage, userInfo, false);
};

export const getUserInfo = () => {
  return JSON.parse(localStorage.getItem('userInfo')) || JSON.parse(sessionStorage.getItem('userInfo'));
};

export const removeUserInfo = () => {
  localStorage.removeItem('userInfo');
  sessionStorage.removeItem('userInfo');
};

export const isLoggedIn = () => {
  const userInfo = getUserInfo();
  return !!userInfo && !!userInfo.token;
};

export const saveRememberMe = (rememberMe) => {
  localStorage.setItem('rememberMe', rememberMe);
};

export const getRememberMe = () => {
  return localStorage.getItem('rememberMe') === 'true';
};


// WEBPACK FOOTER //
// ./src/utils/storage.js